import { render } from "./VideoComponent.vue?vue&type=template&id=268d5021&scoped=true&ts=true"
import script from "./VideoComponent.vue?vue&type=script&lang=ts"
export * from "./VideoComponent.vue?vue&type=script&lang=ts"

import "./VideoComponent.vue?vue&type=style&index=0&id=268d5021&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/hph-sitecore-sites/hph-sitecore-sites/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268d5021"]])

export default __exports__